import React, { useEffect, useState } from "react";
import "./Contact.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaMapMarkerAlt, FaEnvelope, FaPhone, FaClock, FaPaperPlane, FaCheck } from "react-icons/fa";

const Contact = () => {
  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: true,
      offset: 120,
    });
  }, []);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    company: "",
    message: "",
  });

  const [status, setStatus] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");
    setIsLoading(true);

    const payload = {
      access_key: "1692e4fe-7816-49ff-b892-e45e818df60f",
      subject: "New Contact Form Submission - JCRL",
      from_name: "JCRL Website",
      ...formData,
    };

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (result.success) {
        setStatus("Message sent successfully!");
        setIsLoading(false);
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          company: "",
          message: "",
        });
        
        // Clear success message after 5 seconds
        setTimeout(() => {
          setStatus("");
        }, 5000);
      } else {
        setStatus("Something went wrong. Please try again.");
        setIsLoading(false);
      }
    } catch (error) {
      setStatus("Network error. Please try again later.");
      setIsLoading(false);
    }
  };

  return (
    <div className="contact-page">
      {/* ================= HERO SECTION ================= */}
      <section className="contact-hero" data-aos="fade-up">
        <div className="container">
          <div className="contact-hero-content">
            <span className="contact-tag">CONTACT US</span>
            <h1 className="contact-title">
              Get in <span className="gradient-text">Touch</span>
            </h1>
            <p className="contact-subtitle">
              Thank you for taking the time to learn about JCRL.  
              For further information or any queries, please fill out the form below.
            </p>
          </div>
        </div>
      </section>

      {/* ================= MAIN CONTENT ================= */}
      <section className="contact-main-section">
        <div className="container">
          <div className="contact-main-container">
            {/* -------- CONTACT INFO -------- */}
            <div className="contact-info-section" data-aos="fade-right">
              <h2 className="section-title">Contact Information</h2>
              <p className="section-subtitle">
                Reach out to us through any of these channels
              </p>

              <div className="info-cards-grid">
                <div className="info-card">
                  <div className="info-card-icon">
                    <FaMapMarkerAlt />
                  </div>
                  <div className="info-card-content">
                    <h4>Address</h4>
                    <p>
                      Regalia B wing, Casa Bella, Lodha Palava,
                      Dombivli, Maharashtra – 421204
                    </p>
                  </div>
                </div>

                <div className="info-card">
                  <div className="info-card-icon">
                    <FaEnvelope />
                  </div>
                  <div className="info-card-content">
                    <h4>Email</h4>
                    <p>jcrlcornerstonetech@gmail.com</p>
                  </div>
                </div>

                <div className="info-card">
                  <div className="info-card-icon">
                    <FaPhone />
                  </div>
                  <div className="info-card-content">
                    <h4>Phone</h4>
                    <p>+91 9082916236<br />Mon–Fri 9am–6pm</p>
                  </div>
                </div>

                <div className="info-card">
                  <div className="info-card-icon">
                    <FaClock />
                  </div>
                  <div className="info-card-content">
                    <h4>Business Hours</h4>
                    <p>Monday – Friday: 9AM – 6PM<br />Saturday: 10AM - 2PM</p>
                  </div>
                </div>
              </div>

              {/* Social Media Links */}
              <div className="social-links" data-aos="fade-up" data-aos-delay="200">
                <h3>Follow Us</h3>
                <div className="social-icons">
                  <a href="#" className="social-icon" aria-label="LinkedIn">
                    <i className="fab fa-linkedin"></i>
                  </a>
                  <a href="#" className="social-icon" aria-label="Twitter">
                    <i className="fab fa-twitter"></i>
                  </a>
                  <a href="#" className="social-icon" aria-label="Facebook">
                    <i className="fab fa-facebook"></i>
                  </a>
                  <a href="#" className="social-icon" aria-label="Instagram">
                    <i className="fab fa-instagram"></i>
                  </a>
                </div>
              </div>
            </div>

            {/* -------- CONTACT FORM -------- */}
            <div className="contact-form-section" data-aos="fade-left">
              <div className="form-header">
                <div className="form-icon-container">
                  <FaPaperPlane />
                </div>
                <h2>Send us a Message</h2>
                <p className="form-subtitle">We'll get back to you within 24 hours</p>
              </div>

              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="firstName">First Name *</label>
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                      placeholder="Enter your first name"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="lastName">Last Name *</label>
                    <input
                      type="text"
                      id="lastName"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                      placeholder="Enter your last name"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="Enter your email"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Enter your phone number"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="company">Company Name</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    placeholder="Enter your company name"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="5"
                    placeholder="Type your message here..."
                  />
                </div>

                <button 
                  type="submit" 
                  className={`submit-btn ${isLoading ? 'loading' : ''}`}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <span className="spinner"></span>
                      <span>Sending...</span>
                    </>
                  ) : (
                    <>
                      <span>Send Message</span>
                      <span className="arrow">→</span>
                    </>
                  )}
                </button>

                {status && (
                  <div className={`form-status ${status.includes('successfully') ? 'success' : 'error'}`}>
                    {status.includes('successfully') ? <FaCheck /> : '⚠️'}
                    <span>{status}</span>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* ================= MAP SECTION ================= */}
      <section className="location-section">
        <div className="container">
          <div className="location-header">
            <h2 className="section-title">Our Location</h2>
            <p className="section-subtitle">Find us on Google Maps</p>
          </div>
          
          <div className="map-container" data-aos="fade-up">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3847.647703158016!2d73.06698878371786!3d19.174911287537267!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2s!5e0!3m2!1sen!2sin!4v1766034283582!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="JCRL Location - Regalia B wing, Casa Bella, Lodha Palava"
            />
            
            <div className="map-overlay">
              <div className="map-coordinates">
                <div className="coordinate-item">
                  <span className="coord-label">Latitude:</span>
                  <span>19.174911° N</span>
                </div>
                <div className="coordinate-item">
                  <span className="coord-label">Longitude:</span>
                  <span>73.066989° E</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= FAQ SECTION ================= */}
      <section className="faq-section">
        <div className="container">
          <h2 className="section-title">Frequently Asked Questions</h2>
          <div className="faq-grid">
            <div className="faq-item" data-aos="fade-up">
              <h4>What services does JCRL provide?</h4>
              <p>We specialize in IT solutions, software development, digital transformation, and consulting services tailored to your business needs.</p>
            </div>
            <div className="faq-item" data-aos="fade-up" data-aos-delay="100">
              <h4>How quickly will you respond to my inquiry?</h4>
              <p>We aim to respond to all inquiries within 24 hours during business days.</p>
            </div>
            <div className="faq-item" data-aos="fade-up" data-aos-delay="200">
              <h4>Do you provide support after project completion?</h4>
              <p>Yes, we offer comprehensive post-deployment support and maintenance packages.</p>
            </div>
            <div className="faq-item" data-aos="fade-up" data-aos-delay="300">
              <h4>What are your working hours?</h4>
              <p>Our office is open Monday to Friday from 9 AM to 6 PM, and Saturdays from 10 AM to 2 PM.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;